import {mountCatalogSlides} from './pevita-studio--catalog-slides.js?v=magsafe-live20261029a';
import {cartStore} from './pevita-studio--cart-storage.js?v=clarity-fixes-20261030';
import {translate as t} from './pevita-studio--i18n.js?v=clarity-fixes-20261030';
import {customerModels} from './pevita-studio--device-names.js?v=magsafe-live20261029a';
import {expandOfferings} from './pevita-studio--selection.js?v=tpu-magsafe-live-20261029a';
import {buildCatalog} from './pevita-studio--catalog-view.js?v=magsafe-live20261029a';
import {mountStorefront,showStorefront} from './pevita-studio--storefront.js?v=clarity-fixes-20261030';
import {mountHeroSlider} from './pevita-studio--hero-slider.js?v=magsafe-live20261029a';
// Use Shopify's content-versioned URLs; unversioned JSON may stay cached for a year.
const asset=p=>window.PevitaStudioCatalogUrls?.[p]||(window.PevitaStudioAssetBase?window.PevitaStudioAssetBase+'pevita-studio--'+p+'?v=magsafe-live20261029a':p);
let editorRequest,editorReady=false;
// Restore the header count without downloading the editor or its artwork.
async function refreshCartBadge(){
 if(editorRequest)return; // Once loaded, cart-controller owns the live counter.
 const badge=document.getElementById('cart-count');if(!badge)return;
 const results=await Promise.allSettled([
  cartStore.read(),
  window.PevitaCommerce?fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw Error('Cart unavailable');return r.json();}):Promise.resolve({item_count:0})
 ]);
 if(editorRequest)return;
 const local=results[0].status==='fulfilled'?results[0].value.reduce((sum,item)=>sum+item.quantity,0):0;
 const remote=results[1].status==='fulfilled'?results[1].value.item_count:0;
 badge.textContent=results.every(result=>result.status==='rejected')?'—':String(local+remote);
}
window.addEventListener('pageshow',()=>{void refreshCartBadge();});
const home=()=>!location.hash||location.hash.startsWith('#modelo/')||['#','#buscar','#tipos','#ayuda','#como-funciona','#coleccion/todos'].includes(location.hash);
async function navigate(){
 document.getElementById('editor-load-error')?.remove();
 if(editorReady)return;
 if(home()){showStorefront();return;}
 try{editorRequest ||= import('./pevita-studio--studio.js?v=clarity-fixes-20261030').catch(error=>{editorRequest=null;throw error;});await editorRequest;editorReady=true;}
 catch{showStorefront();let status=document.getElementById('editor-load-error');if(!status){status=document.createElement('p');status.id='editor-load-error';status.setAttribute('role','alert');document.getElementById('product-grid').before(status);}status.textContent=t('No se ha podido abrir el editor. Vuelve a intentarlo.');status.scrollIntoView({block:'center'});}
}
async function start(){
 void refreshCartBadge();
 mountHeroSlider();document.getElementById('open-cart').onclick=()=>{location.hash='carrito';};
 try{
  const read=async name=>{const r=await fetch(asset(name));if(!r.ok)throw Error(name);return r.json();};
  const [catalog,store,index]=await Promise.all([read('catalog.json'),read('storefront.json'),read('model-index.json')]);
  const products=expandOfferings(store.products,catalog.products);products.forEach(p=>p.models=customerModels(index.variants.filter(v=>v.family===p.family)));
  buildCatalog(products,catalog.products);mountCatalogSlides();mountStorefront(products);document.documentElement.setAttribute('data-store-ready','');
  window.addEventListener('hashchange',navigate);await navigate();
 }catch{document.getElementById('product-grid').textContent='No se ha podido cargar la colección. Recarga la página para volver a intentarlo.';}
}
start();
